export default __webpack_public_path__ + "static/media/price_tag.618b3aac.svg";